module.exports = __webpack_public_path__ + "img/business_25.0018c781.jpg";